import React from 'react';
import { useTranslation } from 'react-i18next';
import WarningAlertComponent from '../WarningAlert.component';
import { ChildAlertProps } from '../BaseAlert.component';

const AssistantHistoryClearAllAlert = ({ handleConfirm }: ChildAlertProps) => {
  const { t } = useTranslation();

  return (
    <WarningAlertComponent onClose={handleConfirm}>
      {t('assistant.clearAllConfirm')}
      <br />
      {t('Continue')}?
    </WarningAlertComponent>
  );
};

export default AssistantHistoryClearAllAlert;
